export default __webpack_public_path__ + "static/media/karma.acf56e07.mp4";